module.exports = __webpack_public_path__ + "img/bg_dam.beac4200.jpg";